<template>
  <div class="setpwd-page">
    <!-- 顶部导航 -->
    <header class="header">
      <div class="header-back" @click="back()">
        <van-icon name="arrow-left" />
      </div>
      <h1 class="header-title">{{ $t('setting.password_setting') || '密碼設定' }}</h1>
      <div class="header-placeholder"></div>
    </header>

    <!-- 密碼類型切換Tab -->
    <div class="tab-bar">
      <div class="tab-item" :class="{ active: activeTab === 'login' }" @click="switchTab('login')">
        {{ $t('setting.modify_login_pwd') || '修改交易密碼' }}
      </div>
      <div class="tab-item" :class="{ active: activeTab === 'pay' }" @click="switchTab('pay')">
        {{ $t('setting.modify_pay_pwd') || '修改交易密碼' }}
      </div>
    </div>

    <!-- 交易密碼表單 -->
    <div class="form-container" v-if="activeTab === 'login'">
      <!-- 新密碼 -->
      <div class="form-group">
        <div class="label-row">
          <label class="form-label"><span>*</span>{{ $t('setting.new_pwd') || '新密碼' }}</label>
          <span class="show-btn" @click="showLoginNew = !showLoginNew">{{ showLoginNew ? ($t('auth.hide') || '隱藏') : ($t('auth.show') || '顯示') }}</span>
        </div>
        <input v-model="loginFormData.new_password" :type="showLoginNew ? 'text' : 'password'" class="form-input"
          :placeholder="$t('setting.new_pwd_tip') || '請輸入您的新交易密碼'" />
      </div>

      <!-- 確認新密碼 -->
      <div class="form-group">
        <div class="label-row">
          <label class="form-label"><span>*</span>{{ $t('setting.new_pwd1') || '確認新密碼' }}</label>
          <span class="show-btn" @click="showLoginConfirm = !showLoginConfirm">{{ showLoginConfirm ? ($t('auth.hide') || '隱藏') : ($t('auth.show') || '顯示') }}</span>
        </div>
        <input v-model="loginFormData.confirm_password" :type="showLoginConfirm ? 'text' : 'password'" class="form-input"
          :placeholder="$t('setting.new_pay_again_tip') || '請再次輸入您的交易新交易密碼'" />
      </div>

      <!-- 提交按钮 -->
      <button class="submit-btn" @click="saveLoginPwd()">
        {{ $t('setting.save') || '保存' }}
      </button>
    </div>

    <!-- 交易密碼表單 -->
    <div class="form-container" v-if="activeTab === 'pay'">
      <!-- 新密碼 -->
      <div class="form-group">
        <div class="label-row">
          <label class="form-label"><span>*</span>{{ $t('setting.new_pwd') || '新密碼' }}</label>
          <span class="show-btn" @click="showPayNew = !showPayNew">{{ showPayNew ? ($t('auth.hide') || '隱藏') : ($t('auth.show') || '顯示') }}</span>
        </div>
        <input v-model="payFormData.new_password" :type="showPayNew ? 'text' : 'password'" class="form-input"
          :placeholder="$t('setting.new_pay_pwd_tip') || '請輸入您的交易新密碼'" />
      </div>

      <!-- 確認新密碼 -->
      <div class="form-group">
        <div class="label-row">
          <label class="form-label"><span>*</span>{{ $t('setting.new_pwd1') || '確認新密碼' }}</label>
          <span class="show-btn" @click="showPayConfirm = !showPayConfirm">{{ showPayConfirm ? ($t('auth.hide') || '隱藏') : ($t('auth.show') || '顯示') }}</span>
        </div>
        <input v-model="payFormData.confirm_password" :type="showPayConfirm ? 'text' : 'password'" class="form-input"
          :placeholder="$t('setting.old_pay_pwd_tip') || '請再次輸入您的交易新密碼'" />
      </div>

      <!-- 提交按钮 -->
      <button class="submit-btn" @click="savePayPwd()">
        {{ $t('setting.save') || '保存' }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeTab: 'login',
      showLoginNew: false,
      showLoginConfirm: false,
      showPayNew: false,
      showPayConfirm: false,
      loginFormData: {
        new_password: "",
        confirm_password: ""
      },
      payFormData: {
        new_password: "",
        confirm_password: ""
      },
      userInfo: {}
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    switchTab(tab) {
      this.activeTab = tab;
    },
    saveLoginPwd() {
      const form = this.loginFormData;
      if (form.new_password === "" || form.confirm_password === "") {
        this.$toast(this.$t("setting.prefect") || '請填寫完整');
        return false;
      }
      if (form.new_password !== form.confirm_password) {
        this.$toast(this.$t("setting.pwd_error") || '兩次密碼輸入不一致');
        return false;
      }
      this.$http({
        method: 'get',
        data: {
          new_password: form.new_password
        },
        url: 'user_set_loginpw'
      }).then(res => {
        if (res.code === 200) {
          this.$toast(res.msg);
          setTimeout(() => {
            localStorage.clear();
            this.$router.push("Login");
          }, 500);
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    savePayPwd() {
      const form = this.payFormData;
      if (form.new_password === "" || form.confirm_password === "") {
        this.$toast(this.$t("setting.prefect") || '請填寫完整');
        return false;
      }
      if (form.new_password !== form.confirm_password) {
        this.$toast(this.$t("setting.pwd_error") || '兩次密碼輸入不一致');
        return false;
      }
      this.$http({
        method: 'post',
        data: {
          paypassword: form.new_password,
          paypassword2: form.new_password
        },
        url: 'user_set_paypw'
      }).then(res => {
        if (res.code === 200) {
          this.$toast(res.msg);
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' });
    } else {
      this.getUserInfo();
    }
  }
};
</script>

<style lang="less" scoped>
.setpwd-page {
  min-height: 100vh;
  background: #000;
  color: #f5f5f5;
  padding-bottom: 80px;
}

/* 头部 */
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: #000;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.header-back {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 28px;
  color: #fff;
}

.header-title {
  flex: 1;
  text-align: center;
  font-size: 28px;
  font-weight: 700;
  margin: 0;
}

.header-placeholder {
  width: 40px;
}

/* Tab切換 */
.tab-bar {
  display: flex;
  padding: 0 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.tab-item {
	width:50%;
  padding: 16px 20px;
  font-size: 28px;
  color: #999;
  cursor: pointer;
  position: relative;
  text-align: center;
}

.tab-item.active {
	width:50%;
  color: #22cc61;
}

.tab-item.active::after {
  content: "";
  position: absolute;
  left: 130px;
  right: 130px;
  bottom: 0;
  height: 3px;
  background: #22cc61;
  border-radius: 2px;
}

/* 表单容器 */
.form-container {
  padding: 20px 16px;
}

.form-group {
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
}

.form-label {
  font-size: 28px;
  font-weight: 500;
  color: #fff;
  margin-bottom: 8px;
}
.form-label span{
	color:red;
}
.form-input {
  padding: 24px 16px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  background: #444;
  color: #fff;
  font-size: 28px;
  outline: none;
  transition: all 0.3s;
}

.show-btn {
  color: #22cc61;
  font-size: 26px;
  cursor: pointer;
}

.label-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

/* 提交按钮 */
.submit-btn {
  width: 100%;
  padding: 14px 16px;
  margin-top: 30px;
  background: #22cc61;
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 28px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s;

  &:active {
    opacity: 0.9;
    transform: scale(0.98);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
}
</style>
